module.exports = __webpack_public_path__ + "media/images/empath-alt-fab1cadb9962e9d66315ba208e40f707.png";